module.exports = __webpack_public_path__ + "assets/e8446a802aa706356a8ea801001e9c2c.png";